import { useCallback } from 'react';

import clientConfig from '../../client/config';
import { useNotNullableContext } from '../useNotNullableContext';
import { PageMetaContext } from '../../context';

export default function useStravaAuth() {
  const { currentUrl } = useNotNullableContext(PageMetaContext);

  return useCallback(() => {
    const {
      strava: { clientID, scope, authUrl, callbackDomain },
      baseUri,
    } = clientConfig;

    const url = callbackDomain
      ? currentUrl.replace(baseUri, callbackDomain)
      : currentUrl;

    const responseType = 'code';
    const encodedCallbackUrl = encodeURIComponent(url);

    window.location.href = `${authUrl}?client_id=${clientID}&redirect_uri=${encodedCallbackUrl}&response_type=${responseType}&scope=${scope}`;
  }, [currentUrl]);
}
